import { LegalLayout } from "@/pages/LegalLayout";
import { privacidade, privacyEn } from "@/content/legal";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Privacidade() {
  const { lang } = useLanguage();
  return <LegalLayout doc={lang === "pt" ? privacidade : privacyEn} testId="privacy-policy-page" />;
}
